import useScrollPosition from '@hooks/useScrollPosition/useScrollPosition';

const FALLBACK_OFFSET_PERCENTAGE = 0.8;

export interface IUseShouldFetchMoreConfig {
  scrollDelay: number;
  targetScrollOffset: number;
  scrollRef?: React.RefObject<HTMLElement>;
}

const useShouldFetchMore = ({
  scrollDelay,
  targetScrollOffset,
  scrollRef,
}: IUseShouldFetchMoreConfig) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  } else {
    const scrollPosition = useScrollPosition(scrollRef?.current || window, scrollDelay);
    const scrollHeight = scrollRef?.current?.scrollHeight || document.body.scrollHeight;

    const scrollYPosition = scrollPosition ? scrollPosition.y : 0;
    let targetScrollLocation = scrollHeight - targetScrollOffset;

    if (!scrollYPosition) return false;

    /* This is a work around for large screens
      If the target position is within the current screen use a percent as the target */
    if (targetScrollLocation > window.innerHeight) {
      targetScrollLocation = scrollHeight * FALLBACK_OFFSET_PERCENTAGE;
    }
    return (scrollYPosition + window.innerHeight) >= targetScrollLocation;
  }
};

export default useShouldFetchMore;
